export const projects = [
  {
    title: "AI Chatbot",
    desc: "A cloud computing project built with generative AI to answer FAQs about NTU.",
    tags: [
      {
        name: "Python",
        color: "red-600",
      },
      {
        name: "Jupyter Notebook",
        color: "green-600",
      },
      {
        name: "Generative AI",
        color: "Blue-600",
      },
    ],
    img: "https://i.gyazo.com/9e93525cb2a288ccde13b6f9dc0bc343.png",
    link: "",
    code: "https://github.com/KuroZenon/KRBrendonCloudCP",
  },
  {
    title: "Suicide Prevention Squad",
    desc: "A data science project which explores factors affecting suicide rates through the use of exploratory data analysis and machine learning models.",
    tags: [
      {
        name: "Python",
        color: "red-600",
      },
      {
        name: "Jupyter Notebook",
        color: "green-600",
      },
    ],
    img: "https://i.gyazo.com/2c394a3deacc499724354ddb4590fa89.png",
    link: "",
    code: "https://github.com/brendontan03/SC1015",
  },
  {
    title: "Fast & Furious",
    desc: "An app made with android studio to facilitate fast and easy transportation.",
    tags: [
      {
        name: "Python",
        color: "red-600",
      },
      {
        name: "Java",
        color: "green-600",
      },
      {
        name: "FireBase",
        color: "yellow-600",
      },
    ],
    img: "https://i.gyazo.com/da425d4246fe4f9060fbaa783008ac0b.png",
    code: "https://github.com/brendontan03/Fast-And-Furious",
  },
];
